export const limitText = (text: string | number | undefined, limit: number) => {
	return text && text.toString().length > limit ? text.toString().substr(0, limit) + '...' : text;
};
